











import Vue from 'vue'
import style from './style.module.scss'

import numeric from 'vue-numeric-input'

export default Vue.extend({
    name: 'number-input',
    components: {
        numeric
    },
    props: {
        value: Number
    },
    data() {
        return {
            style: style
        }
    },
    methods: {
        up(): void {
            const newValue = this.model + 1;
            this.$emit('input', newValue)
        },
        down(): void {
            const newValue = this.model - 1;
            if (newValue > 0) {
                this.$emit('input', newValue)
            }
        },
        emitInput(newValue: number): void {
            this.$emit('input', isNaN(newValue) ? null : newValue);
        }
    },
    computed: {
        model: {
            get(): number {
                return this.value;
            },
            set(value: number): void {
                this.$emit('input', value);
            }
            
        }
    }
})
